import { VFC } from 'react';

import Card from 'design-system/components/Card';
import { Paragraph } from 'design-system/components/Text';

export const SARInstructionsCard: VFC = () => (
  <Card>
    <Card.Body>
      <Card.Title>Instructions</Card.Title>

      <Paragraph>
        Complete the report in its entirety with all required and known requested data provided.
        Click validate to ensure the report has no errors.
      </Paragraph>
      <Paragraph>
        Questions on the SAR form?{' '}
        <a
          target='_blank'
          href='https://www.fincen.gov/frequently-asked-questions-regarding-fincen-suspicious-activity-report-sar'
          rel='noreferrer'
        >
          Click here to visit BSA&apos;s Support Center.
        </a>
      </Paragraph>
    </Card.Body>
  </Card>
);
